<!-- ALL ORIGINAL ANGULARJS STRUCTURE MIGRATED TO ANGULAR 12 -->
<!-- Original: ui/app/components/dashboardExecutive/footNotes/foot-notes.html -->

<div class="app-foot-eng">
  <!-- Filter Bar -->
  <div class="gt-filter-container">
    <div class="filter-left-controls">
      <div class="col">
        <div class="btn-group" role="group">
          <button type="button" class="btn filter-selection filter-btn"
                  [class.active]="selectedFilterType === 'C'"
                  (click)="switchFilters('C')">
            Corporation
          </button>
          <button type="button" class="btn filter-selection filter-btn"
                  [class.active]="selectedFilterType === 'P'"
                  (click)="switchFilters('P')">
            Partnership
          </button>
        </div>
      </div>
      <div class="col filter-separator"></div>
    </div>

    @if (selectedFilterType === 'C') {
<div class="col filters-corp filters">
      <span>Footnotes are not available for Corporation!</span>
    </div>
}

    @if (selectedFilterType === 'P') {
<div class="col filters-part filters">
      <div class="col">
        <div class="btn-group" role="group">
          <button type="button" class="btn filter-selection filter-btn active">
            Domestic
          </button>
          <button type="button" class="btn filter-selection filter-btn" disabled>
            Foreign
          </button>
        </div>
      </div>
      <div class="col">
        @if (hoLoading) {
<div class="search-dropdown-loader filter-loader">
          <i class="fa fa-spinner fa-spin"></i>
        </div>
}
        @if (!hoLoading) {
<select class="ho-dropdown-select" 
                [(ngModel)]="selectedHO" 
                (ngModelChange)="changeHO()"
                [compareWith]="compareHO"
               >
          <option [ngValue]="null" disabled selected>Select an HO...</option>
          @for (ho of hoList; track $index) {
<option [ngValue]="ho">{{ ho.name }}</option>
}
        </select>
}
      </div>
      <div class="col">
        <select class="pad-adjust" [(ngModel)]="selectedForm" (ngModelChange)="changeForm()"
                [disabled]="hoLoading">
          @for (form of formScheduleList; track $index) {
<option [ngValue]="form">{{ form.form }}</option>
}
        </select>
      </div>
      @if (!hideSchedules) {
<div class="col">
        <select class="pad-adjust" [(ngModel)]="selectedSchedule" [disabled]="hoLoading">
          @for (sch of scheduleList; track $index) {
<option [ngValue]="sch">{{ sch }}</option>
}
        </select>
      </div>
}
      @if (selectedSchedule !== 'NA' && !hidePartners) {
<div class="col">
        <select class="pad-adjust" [(ngModel)]="selectedPartner" [disabled]="hoLoading">
          @for (partner of partners; track $index) {
<option [ngValue]="partner">{{ partner.le_name }}</option>
}
        </select>
      </div>
}
      <div class="col">
        <div class="btn btn-success btn-xs filter-btn" style="padding: 3px 5px;"
             [class.disabled]="!selectedHO || !selectedForm || selectedPartner === undefined"
             (click)="onFilterClick()">
          Filter
        </div>
      </div>
    </div>
}
  </div>

  <!-- Main Content Area -->
  <div class="wrapper">
    <!-- Initial State Image -->
    @if (!footNotesLoaded && !footNotesLoading) {
<img src="assets/img/dashboard-filter-indicator.jpg" alt="filter image"
         style="width: 100%; height: 100%; object-fit: cover;"
        >
}

    <!-- Loading State -->
    @if (!footNotesLoaded && footNotesLoading) {
<div class="gg-loader" style="display: block; width: 100%; height: 100%; z-index: 0;"
        >
      <div class="gg-loader-text">
        <div class="gt-loader-logo">
          <img class="loader" src="assets/img/loader-yellow-slow.svg" width="140" height="140" alt="loader image">
          <img class="logo" src="assets/img/logo-60.png" alt="loader logo">
          <div class="text">fetching data</div>
        </div>
      </div>
    </div>
}

    <!-- Left Panel: Note List -->
    @if (footNotesLoaded) {
<div class="left-container">
      <div id="add-note" (click)="addNote()">
        <span>+</span> <span>Add Note</span>
      </div>
      <ul>
        @for (note of footNotes; track $index) {
<li
            [class.active]="note.active"
            (click)="!note.active ? noteSelected(note) : null">
          @if (!note.input) {
<span (dblclick)="enableTitleEdit(note)">{{ note.note_name }}</span>
}
          @if (note.input) {
<input class="new-note-input" [(ngModel)]="note.note_name"
                
                 (blur)="finishTitleEdit(note)"
                 (keyup.enter)="finishTitleEdit(note)"/>
}
          @if (note.contentLoading) {
<span class="pull-right">
            <i class="fa fa-spinner fa-spin"></i>
          </span>
}
        </li>
}
      </ul>
    </div>
}

    <!-- Right Panel: Editor -->
    @if (footNotesLoaded && footNotes.length > 0) {
<div class="right-container">
      <div class="editor-container">
        @if (activeNote && !activeNote.titleInput) {
<h3 class="note-title" (dblclick)="enableActiveTitleEdit()"
           >
          {{ activeNote?.note_name }}
        </h3>
}
        @if (activeNote && activeNote.titleInput) {
<input class="note-title title-input" [(ngModel)]="activeNote.note_name"
              
               (blur)="finishActiveTitleEdit()"
               (keyup.enter)="finishActiveTitleEdit()"/>
}

        <i class="fa fa-trash delete pull-right" title="Delete Note" id="delete-note"
           [hidden]="!activeNote || !activeNote.note_id"
           (click)="deleteNote()"></i>
        <i class="fa fa-clipboard clone pull-right" title="Copy Note" id="copy-note"
           (click)="cloneNote()"></i>
        <img class="pdf-export" title="Preview Note" (click)="exportPdf()"
             src="./assets/img/pdfsmall.png">

        <!-- CKEditor Container -->
        <div class="document-editor">
          <div class="document-editor__toolbar" #editorToolbar></div>
          <div class="document-editor__editable-container">
            <div class="document-editor__editable" #editorEditable></div>
          </div>
        </div>

        <button class="btn btn-success mt-10 pull-right"
                (click)="saveContent()"
                [disabled]="saving || deletingNote">
          {{ !saving ? 'Save' : '' }}
          @if (saving) {
<span><i class="fa fa-spinner fa-spin"></i></span>
}
        </button>
      </div>
    </div>
}

    <!-- No FootNotes Message -->
    @if (footNotesLoaded && footNotes.length === 0) {
<div class="no-foot-notes">
      <h2>Click on 'Add Note' to add a new Note.</h2>
    </div>
}
  </div>
</div>
